import React from 'react';
import {Button, Flex} from '@priority-software/priority-style-react';
import styles from '../styles/settingsPanel.module.scss';
import texts from '../../texts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type SettingsFooter = {
    isDirty: boolean;
    onCancel: () => void;
    onApply: () => void;
};
export const Footer = ({isDirty, onCancel, onApply}: SettingsFooter) => {
    return (
        <Flex
            justifyContent="flex-end"
            alignItems="center"
            componentClasses={styles.settingsFooter}
            {...createDataTestId(`attachments-settings-footer`, true)}
        >
            <Button
                skin="secondary"
                size="small"
                componentClasses={styles.settingsButton}
                onClick={onCancel}
            >
                {texts.cancel}
            </Button>
            <Button
                skin="primary"
                size="small"
                disabled={!isDirty}
                componentClasses={styles.settingsButton}
                onClick={onApply}
            >
                {texts.confirm}
            </Button>
        </Flex>
    );
};
